/*
 * CSS Injections
 */
function injectcss(stylesheet) {
  if (!document.querySelector(`link[href='${stylesheet}']`)?.length) {
    if (!window.diem.css.includes(stylesheet)) {
      $(`<link href="${stylesheet}" rel="stylesheet">`).appendTo('head');
      window.diem.css.push(stylesheet);
    }
  }
}

/*
 * JS Injections
 */
function injectjs(src) {
  if (!document.querySelector(`script[href='${src}']`)?.length) {
    if (!window.diem.js.includes(src)) {
      const tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.body.appendChild(tag);
      window.diem.js.push(src);
    }
  }
}

/*
 * Session Storage utils
 */

function resetCustomerSessionData() {
  sessionStorage.removeItem('@customerSession');
}

function setCustomerSessionData(key = '', value = '') {
  if (!key || !value) {
    return;
  }

  const prevSession = JSON.parse(sessionStorage.getItem('@customerSession') ?? '{}');
  const data =
    key === '@customerSession'
      ? { ...prevSession, ...value }
      : { ...prevSession, [key]: value };

  sessionStorage.setItem('@customerSession', JSON.stringify(data));
}

function getCustomerSessionData(key) {
  const data = JSON.parse(sessionStorage.getItem('@customerSession') ?? '{}') ?? {};

  return key ? data?.[key] : data;
}

/*
 * Upcart API
 */
window.upcartOnAddToCart = (id, quantity, item) => {
  document.dispatchEvent(
    new CustomEvent('upcart:add', {
      bubbles: true,
      detail: {
        id,
        quantity,
        item,
      },
    })
  );
};